import React from 'react';
import classes from './Footer.module.css';
import { withRouter } from 'react-router-dom';
// import { Constants } from '../../Constants';

const Footer = ({ history }) => {
  const FooterLinks = () => (
    <span className={classes['footer-link-container']}>
      <a
        href="https://lntermsandconditions.blob.core.windows.net/tnc/tpmpfaq.html"
        className={classes.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        FAQs
      </a>
      {/* {showTermsOfUse ? (
        <>
          <span>|</span>
          <a
            href="https://lntermsandconditions.blob.core.windows.net/tnc/tnc.html"
            className={classes.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Use
          </a>
          |
          <a
            href="https://lntermsandconditions.blob.core.windows.net/tnc/privacypolicy.html"
            target="_blank"
            rel="noopener noreferrer"
            className={classes.link}
          >
            Privacy Policy
          </a>
        </>
      ) : null} */}
    </span>
  );

  return (
    <div id="footer" className={classes['app-footer']}>
      <div className={classes['footer-text']}>
        <span>© 2026 LogisticsNow. All Rights Reserved.</span>
        <FooterLinks />
      </div>
    </div>
  );
};

export default withRouter(Footer);
